// El contrato entre `aplicar.ts` (React) y el script inline de `index.html` (antes de
// React). El script no puede importar nada: lee de localStorage un snapshot con TODO lo
// que necesita para pintar el primer frame con el branding del cliente y no con el azul
// de Atlas. `arranque.test.ts` verifica que los dos lados usan las mismas claves.

import { SLUG_ATLAS, VARIABLE_CSS_POR_COLOR, type Branding, type ColoresDeBranding } from './catalogo';
import { hexARgbTriple } from './color';

/** localStorage: el snapshot del último branding aplicado en este dispositivo. */
export const CLAVE_DE_BRANDING_EN_DISPOSITIVO = 'atlas-branding';
/** sessionStorage: el slug que vino por `?branding=`, pegado a esta pestaña. */
export const CLAVE_DE_BRANDING_FORZADO = 'atlas-branding-forzado';
/** Atributo de `<html>` con el slug activo (no se pone para Atlas). Útil para CSS y para mirar qué hay aplicado. */
export const ATRIBUTO_DE_BRANDING = 'data-branding';

export interface SnapshotDeBranding {
  slug: string;
  titulo: string;
  favicon: string;
  manifest: string;
  /** Variable CSS → valor. Vacío para Atlas: ahí manda `:root` de `index.css`. */
  variables: Record<string, string>;
}

/** Cada color como su variable y, al lado, el triple rgb para las formas con opacidad. */
export function variablesCssDe(colores: ColoresDeBranding): Record<string, string> {
  const vars: Record<string, string> = {};
  for (const [color, variable] of Object.entries(VARIABLE_CSS_POR_COLOR)) {
    const hex = colores[color as keyof ColoresDeBranding];
    vars[variable] = hex;
    vars[`${variable}-rgb`] = hexARgbTriple(hex);
  }
  return vars;
}

export function snapshotDeBranding(b: Branding): SnapshotDeBranding {
  return {
    slug: b.slug,
    titulo: b.titulo,
    favicon: b.favicon,
    manifest: b.manifest,
    variables: b.slug === SLUG_ATLAS ? {} : variablesCssDe(b.colores),
  };
}
